// extracted by mini-css-extract-plugin
export default {"surface":"LayoutViewContainer_surface__NHPk-"};